import { Tooltip } from "@mui/material"
import type { FC } from "react"

import type { InvoiceAs400SyncState } from "../types/invoiceAs400Sync"
import { getInvoiceAs400SyncIndicatorConfig } from "../utils/invoiceAs400Sync"

import { InvoiceAs400SyncIcon } from "./InvoiceAs400SyncIcon"

interface InvoiceAs400SyncIndicatorProps {
  invoice: InvoiceAs400SyncState
}

export const InvoiceAs400SyncIndicator: FC<InvoiceAs400SyncIndicatorProps> = ({ invoice }) => {
  const indicatorConfig = getInvoiceAs400SyncIndicatorConfig(invoice)

  if (!indicatorConfig) return null

  return (
    <Tooltip title={indicatorConfig.tooltip}>
      <InvoiceAs400SyncIcon variant={indicatorConfig.variant} />
    </Tooltip>
  )
}
